import
  React
from 'react';

import
  PropTypes
from 'prop-types';

import {
  Subtitle
} from 'src/StyledComponents/Subtitle';

import {
  NewCustomerSuccessIcon
} from 'src/Components/Common/Svg';

import './DealsSuccess.css';

const DealSuccess = (props) => {

  return (

    <div className="deals-for-ftths-success-container">

      <div className="deals-wrapper">
        <NewCustomerSuccessIcon />
      </div>

      <Subtitle aligntext="center" color="#428600" style={{ fontSize: '18px'}}>
        Your application has been submitted. We’ll be in touch shortly.
      </Subtitle>

      { props.referenceNo &&

        <div className='deal-success-reference-container'>

          <hr className='deal-success-divider'/>

          <Subtitle marginTop={'12px'} style={{ fontSize: '18px', fontWeight: 'bold'  }}>
            Reference number: {props.referenceNo}
          </Subtitle>
        </div>

      }
    </div>
  );
};

DealSuccess.propTypes = {
  referenceNo: PropTypes.string,
};

export default DealSuccess;
